import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SeoService } from '../../Shared/seo/seo.service';

@Component({
  selector: 'app-subscription-agreement',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './subscription-agreement.html',
  styleUrl: './subscription-agreement.css',
})
export class SubscriptionAgreementComponent implements OnInit {
  readonly lastUpdated = 'June 23, 2026';
  private seo = inject(SeoService);

  ngOnInit(): void {
    this.seo.update({
      title: 'Subscription Agreement',
      description: 'Terms that apply to your orderYaa ERP subscription.',
      path: '/subscription-agreement',
      robots: 'noindex, follow',
    });
  }
}
